// Is a given value equal to null?
export default function isNull(obj) {
  return obj === null;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/isNull.js
// module id = 225
// module chunks = 0 1